import Image from "next/image";
import React from "react";
import styles from "./upsc-mains-test-series-2023.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Image1 from "next/legacy/image";
import handIcon from "../../assets/images/header/touch-01.png";
import crashcourse from "../../assets/images/home/Moksha/Moksha-2026-Web-Banner.jpg";
import Mobcrashcourse from "../../assets/images/home/Moksha/Moksha-2026-Mob-Banner.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import Upsc_Prelims_form from "../../components/Forms/upsc-mains-forms";
import UPSC_moksha from "./moksha";
import UPSC_series from "./series";
import UPSC_classes from "./classes";
import Link from "next/link";
import Head from "next/head";

const UPSC_Main_Test_Series_2023 = () => {
    const BGimg = [
        //{ img: carouselBGimg4, alt: "carousel", link: "/" },
        //{ img: carouselBGimg3, alt: "carousel", link: "/upsc-mains-test-series" }
    ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>UPSC Mains Test Series 2026 | Shankar IAS Academy</title>
            <meta name="title" content="UPSC Mains Test Series 2026 | Shankar IAS Academy" />
            <meta name="description" content="Prepare effectively with Shankar IAS Academy's UPSC Mains Test Series 2026. Expert guidance, comprehensive materials, and personalized support." />
            <link rel="canonical" href=" https://www.shankariasacademy.com/upsc-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Mains Test Series 2026 | Shankar IAS Academy" />
            <meta property="og:description" content="Prepare effectively with Shankar IAS Academy's UPSC Mains Test Series 2026. Expert guidance, comprehensive materials, and personalized support." />
            <meta property="og:url" content=" https://www.shankariasacademy.com/upsc-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>


            <Navbar title="upsc" />

             <div className="container">
                    <div className="col-md-6 pt-2 ">
                        <h1 className={`${styles.pagemaintitle}`}>UPSC Mains Test Series - Moksha 2026</h1>
                    </div>
            </div>

            <div className="container">

                <div className="row d-none d-md-block">
                <div className="col mb-3">
                <Image
                    src={crashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div>
                </div>

                <div className="row d-block d-md-none">
            <div className="col mb-3">
                <Image
                    src={Mobcrashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
                </div>
                </div> 

            </div>
            

            <div className="container">
                
                <div className="col px-0 d-none d-md-block">
                    <Carousel>
                        {BGimg.map((e) =>
                            <Carousel.Item>
                                <div className="carousemaindiv">
                                    <Link href={e.link} rel="noreferrer"> <Image
                                        className="d-none d-md-block carouselimage"
                                        layout="fill"
                                        src={e.img}
                                        alt={e.alt}
                                        title="description"
                                    /></Link>
                                </div>
                            </Carousel.Item>
                        )}
                    </Carousel>
                </div>
                {/* small screen */}
                <div className="col px-0 d-block d-md-none">
                    <Carousel>
                        {BGimg.map((e) =>
                            <Carousel.Item>
                                <div className="smalldiv">
                                    <Link href={e.link} rel="noreferrer"> <Image
                                        className="d-block d-md-none carouselimage"
                                        layout="fill"
                                        src={e.img}
                                        alt={e.alt}
                                        title="description"
                                    /></Link>
                                </div>
                            </Carousel.Item>
                        )}
                    </Carousel>
                </div>
                
            </div>

            

            {/* <div className="container">
            <div className="row">
                <div className="col mb-2 mb-md-3">
                    <Image src={UPSC} className="img-fluid w-100" alt="upsc-mains-test-series-2023 banner" title="UPSC Main Test Series 2023"/>
                </div>
            </div>
        </div> */}

            {/* <Upsc_Prelims_form /> */}

            

            <UPSC_series />
            
            <UPSC_moksha />
            

            <Footer />
        </>
    )
}
export default UPSC_Main_Test_Series_2023;
